// Import package components
import { useState, useContext, useCallback, useEffect, useMemo } from "react";
import { Flex } from "uikit-react";
import { useCookies } from "react-cookie";

import Pagination from "../../common/Pagination";
import { AppContexts } from "../../../providers";
import RecordsPerPage from "../../common/RecordsPerPage";

const Macros = () => {

  return (
    <li className="reports-tab-content">
      <h2>Property Macros</h2>
      <div className="uk-card hms-left-tabs-content-card uk-padding-remove">
        <p>This report has moved to Guestbook → <a href="/property-field-values">Property Field Values</a>.</p>
      </div>
    </li>
  );
};

export default Macros;
